import {
  B100,
  B300,
  B400,
  B50,
  G300,
  linkHover,
  N0,
  N10,
  N100,
  N20,
  N200,
  N40,
  N400,
  N500,
  N60,
  N600,
  N700,
  N80,
  N800,
  N90,
  N900,
  R400
} from '@atlaskit/theme/colors';
import { TooltipPrimitive } from '@atlaskit/tooltip';
import styled from '@emotion/styled';
import React from 'react';

const text =
  "Charlie Text, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif";

const display =
  "Charlie Display, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif";

const product =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif";

const WacSignupFormContainer = styled.form`
  box-sizing: border-box;
  font-family: ${text};
  font-weight: 500;
  max-width: 400px;
  * {
    box-sizing: border-box;
  }
`;
const ResendEmailContainer = styled.div`
  box-sizing: border-box;
  font-family: ${text};
  font-weight: 500;
  max-width: 536px;
  min-height: 564px;
  margin: 0 auto;
  * {
    box-sizing: border-box;
  }
`;

const StyledPassword = styled.div<SharedProps>`
  opacity: ${(props) => {
    if (props.isDisabled && props.fadeOnDisable) {
      return 0.4;
    }
    return 1;
  }};
  div {
    div:nth-child(2) {
      padding: 4px;
    }
  }
`;

const FieldContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
`;

interface FieldErrorStateProps {
  showError: boolean;
}
const FieldErrorState = styled.div<FieldErrorStateProps>`
  padding: 0;
  background-color: ${(props) => {
    if (props.showError) {
      return R400;
    } else {
      return 'transparent';
    }
  }};
  border-radius: 3px;
`;

const FullNameFieldWrapper = styled.div`
  position: relative;
  margin-bottom: 16px;
`;

const TwoColumnFieldGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
`;

interface NameProps {
  isValid: boolean;
  val: string;
  isDisabled?: boolean;
  fadeOnDisable?: boolean;
  outlineOnFocus?: boolean;
  isFocused?: boolean;
}
const NameFieldGroup = styled.div<NameProps>`
  transition: all 0.1s linear 0s;
  opacity: ${(props) => {
    if (props.isDisabled && props.fadeOnDisable) {
      return 0.4;
    }
    return 1;
  }};
  > div {
    border-color: ${(props) => {
      if (props.isDisabled) {
        return `${N60} !important`;
      }
      if (props.isValid && props.val.length > 0) {
        return '#36b37e';
      } else if (!props.isValid) {
        return R400;
      }
      if (props.outlineOnFocus && props.isFocused) {
        return `${B100}`;
      }
      return N60;
    }};
    background: ${N0} !important;
  }
`;

const Input = styled.input`
  border: 2px solid ${N60};
  border-radius: 4px;
  color: ${N700};
  display: inline-block;
  font-size: 1rem;
  outline: none;
  padding: 8px;
  width: 100%;
  &.field-error {
    border-color: ${R400};
  }
`;

export const InfoIcon = styled.div`
  height: 24px;
  svg {
    margin: 0;
  }
  div {
    display: none;
  }
  :hover {
    div {
      display: block;
    }
  }
`;

const Label = styled.label<SharedProps>`
  transition: all 0.1s linear 0s;
  opacity: ${(props) => {
    if (props.isDisabled && props.fadeOnDisable) {
      return 0.4;
    }
    return 1;
  }};
  span {
    color: ${N500};
    display: inline-block;
    font-size: 0.875rem;
    font-weight: 500;
    margin-bottom: 5px;
    line-height: normal;
    ::after {
      color: ${R400};
      content: '*';
      display: inline-block;
      padding-left: 4px;

      .no-asterisks & {
        content: '';
      }
    }
  }
  display: flex;
`;

const InputSiteNameMessage = styled.label<SharedProps>`
  color: ${N600};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
  text-align: center;
`;

const InputSiteNameInstructions = styled.label<SharedProps>`
  color: ${N500};
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Charlie Text;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  width: 375px;
`;

const LabelDefaultExpandedEmail = styled.label<SharedProps>`
  transition: all 0.1s linear 0s;
  opacity: ${(props) => {
    if (props.isDisabled && props.fadeOnDisable) {
      return 0.4;
    }
    return 1;
  }};
  span {
    color: ${N500};
    display: inline-block;
    font-size: 0.875rem;
    font-weight: 500;
    margin-bottom: 4px;
    line-height: normal;
    ::after {
      color: ${R400};
      content: '*';
      display: inline-block;
      padding-left: 5px;

      .no-asterisks & {
        content: '';
      }
    }
  }
  display: flex;
`;

const ChooseSignupLabel = styled.label<SharedProps>`
  transition: all 0.1s linear 0s;
  opacity: ${(props) => {
    if (props.isDisabled && props.fadeOnDisable) {
      return 0.4;
    }
    return 1;
  }};
  span {
    color: ${N800};
    display: inline-block;
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 4px;
    line-height: 18px;
    ::after {
      color: ${R400};
      content: '*';
      display: inline-block;
      padding-left: 5px;

      .no-asterisks & {
        content: '';
      }
    }
  }
  display: flex;
`;

const InputDescription = styled.div`
  color: ${N500};
  font-weight: 400;
  font-size: 12px;
  margin: 3px 0px;
`;

const DropdownTrigger = styled.div`
  font-family: ${text};
  text-align: left;
  font-size: 14px;
  span: {
    fontsize: '14px';
  }
`;

// Atlaskit dropdown button theme prop
const DropdownButtonStyle = {
  width: '100%',
  background: N0,
  appearance: 'none',
  cursor: 'pointer',
  fontSize: '14px',
  color: text,
  paddingTop: '6px',
  paddingBottom: '6px',
  borderColor: N60,
  borderRadius: '3px',
  borderWidth: '2px',
  borderStyle: 'solid'
};

const OrganizationDropdownButtonStyle = {
  width: '100%',
  height: '32px',
  borderRadius: '3px',
  background: N0,
  borderColor: 'transparent',
  color: N800
};

const JswTrialNotice = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${text};
  margin: 6px 0 4px;

  span {
    min-width: 28px;
    vertical-align: middle;
  }
`;

const DropdownButtonStyleOpen = {
  background: N20,
  borderColor: B100
};

const OrganizationDropdownButtonStyleOpen = {
  background: N0,
  borderColor: 'transparent',
  color: '#0C66E4'
};

const SiteNameAfter = styled.div`
  padding-right: 8px;
  display: flex;
  font-size: 16px;
  align-items: center;
  justify-content: flex-end;
  width: auto;
  color: #7a869a;
  font-weight: 400;
  svg {
    margin-bottom: 0px;
  }
  span {
    display: flex;
    align-items: center;
    min-width: 24px;
  }
`;
const SiteNameAfterRadioList = styled.div`
  padding-right: 8px;
  display: flex;
  font-size: 14px;
  align-items: center;
  justify-content: flex-start;
  width: auto;
  color: #7a869a;
  svg {
    margin-bottom: 0px;
  }
  span {
    display: flex;
    align-items: center;
  }
`;
const SiteNameAfterLabel = styled.span`
  font-size: 14px !important;
  white-space: nowrap;
  padding-right: 8px;
`;

const EmailAfter = styled.div`
  padding-right: 8px;
  display: flex;
  font-size: 16px;
  align-items: center;
  svg {
    margin-bottom: 0px;
  }
`;
interface SharedProps {
  readonly isValid?: boolean;
  readonly textInput?: string;
  readonly hasAccount?: boolean;
  readonly isEmpty?: boolean;
  readonly isFocused?: boolean;
  readonly isDisabled?: boolean;
  readonly popOverError?: boolean; // popover error style type
  readonly outlineOnFocus?: boolean; // blue outline on focus
  readonly fadeOnDisable?: boolean; // fade entire field if disabled
  readonly children?: React.ReactNode;
  readonly className?: string;
  readonly onClick?: (event: any) => void;
  readonly isValidating?: boolean;
}

const SuccessTextfieldWrapper = styled.div<SharedProps>`
  .errorMessage {
    background-color: white !important;
  }
  #site-field {
    padding-right: 0px;
  }
  > div {
    transition: all 0.1s linear 0s;
    max-height: 40px;
    opacity: ${(props) => {
      if (props.isDisabled && props.fadeOnDisable) {
        return 0.4;
      }
      return 1;
    }};
    background: ${N0};
    background: ${(props) => {
      if (props.hasAccount) {
        return `${N20} !important;`;
      }
      return `${N0};`;
    }};
    border-color: ${(props) => {
      if (props.isEmpty || props.hasAccount || props.isDisabled) {
        if (props.outlineOnFocus && props.isFocused) {
          return `${B100} !important`; // blue
        }
        return `${N60} !important`; // dark-grey
      }
      if (props.isValidating) {
        return `${B100} !important`; // blue
      }
      if (props.isValid) {
        return `${G300} !important`; // green
      }
      return `${R400} !important`; // red
    }};
  }
  > input {
    background: ${(props) => {
      if (props.hasAccount) {
        return '#F4F5F7';
      }
      return '#FFFFFF';
    }};
  }
`;

const ChooseSignupSuccessTextfieldWrapper = styled.div<SharedProps>`
  .errorMessage {
    background-color: white !important;
  }
  #site-field {
    padding-right: 0px;
  }
  > div {
    transition: all 0.1s linear 0s;
    max-height: 40px;
    opacity: ${(props) => {
      if (props.isDisabled && props.fadeOnDisable) {
        return 0.4;
      }
      return 1;
    }};
    background: ${N0};
    background: ${(props) => {
      if (props.hasAccount) {
        return `${N20} !important;`;
      }
      return `${N0};`;
    }};
    border-color: ${(props) => {
      if (props.isValid) {
        return `${G300} !important`; // green
      }
      if (props.isFocused || props.hasAccount || props.isDisabled) {
        if (props.outlineOnFocus) {
          return `${B100} !important`; // blue
        }
        return `${N60} !important`; // dark-grey
      }
      return `${R400} !important`; // red
    }};
  }
  > input {
    background: ${(props) => {
      if (props.hasAccount) {
        return '#F4F5F7';
      }
      return '#FFFFFF';
    }};
  }
`;

const ErrorTextfieldWrapper = styled.div`
  > div {
    border-color: ${R400}!important;
  }
`;

const CompoundField = styled.div<SharedProps>`
  transition: all 0.1s linear 0s;
  display: grid;
  grid-template-columns: max-content 1fr;
  margin-bottom: 5px;
  border-radius: 3px 0 0 3px;
  opacity: ${(props) => {
    if (props.isDisabled && props.fadeOnDisable) {
      return 0.4;
    }
    return 1;
  }};
  > div {
    > div {
      transition: all 0.1s linear 0s;
      border-right: none;
      border-radius: 3px 0 0 3px;
      background: ${N0} !important;
      border-color: ${(props) => {
        if (props.isEmpty || props.isDisabled) {
          if (props.outlineOnFocus && props.isFocused) {
            return `${B100} !important`;
          }
          return `${N60} !important`;
        }
        if (props.isValid) {
          return `${G300} !important`;
        }
        return `${R400}`;
      }};
    }
  }

  > label {
    > span {
      margin: 0;
    }
  }

  .domain-name-tooltip-trigger {
    border-color: ${B400};
    border-right: 1px solid;
    border-radius: 3px;
  }
  .domain-name-tooltip-trigger-devops {
    background: ${N0};
    border-color: ${N0};
    box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    border-radius: 3px;
  }
`;

export const PasswordCompoundField = styled(CompoundField)<SharedProps>`
  display: flex;
  .full-width {
    width: 100%;
  }
`;

const CompoundInput = styled(Input)`
  @supports (display: grid) {
    border-radius: 4px 0 0 4px;
    border-right: none;
    margin: 0;
    min-height: 40px;
    padding-right: 0;
  }
`;

const CompoundInputSegment = styled.div<SharedProps>`
  @supports (display: grid) {
    transition: all 0.1s linear 0s;
    border: 2px solid ${N60};
    border-radius: 0 4px 4px 0;
    border-color: ${(props) => {
      if (props.isEmpty || props.isDisabled) {
        if (props.outlineOnFocus && props.isFocused) {
          return `${B100} !important`;
        }
        return `${N60} !important`;
      }
      if (props.isValid) {
        return `${G300} !important`;
      }
      return `${R400} !important`;
    }};
    border-left: none;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 4px 8px;
    &.field-error {
      border-color: ${R400};
    }
  }
`;

const ErrorMessage = styled.div<SharedProps>`
  color: ${R400};
  font-weight: 400;
  margin: 6px 0;
  font-size: 12px;
  line-height: 12px;

  a {
    text-decoration: none;
    color: ${B400};

    &:hover {
      text-decoration: underline;
      color: ${B300};
    }
  }

  ${(props) =>
    props.popOverError &&
    `
    position: absolute;
    display: ${props.isDisabled && props.fadeOnDisable ? 'none' : 'grid'};
    justify-items: center;
    align-items: start;
    width: 100%;
    margin: 0;
    z-index: 9;
    color: ${N900};
    background: transparent !important;

    span {
      padding: 7px;
      background: white;
      box-shadow: 0px 0px 1px rgba(9, 30, 66, 0.31), 0px 3px 5px rgba(9, 30, 66, 0.2);
      border-radius: 3px;
      margin-top: 2px;
      max-width: 90%;
      line-height: 1.2em;
    }
  `}
`;

function ErrorMessageWithDefaultClassName({
  className,
  ...props
}: SharedProps) {
  return (
    <ErrorMessage
      className={`errorMessage ${!!className ? className : ''}`}
      {...props}
    >
      {props.children}
    </ErrorMessage>
  );
}

export const RadioGroupWrapper = styled.div`
  line-height: 1;
  margin-bottom: 12px;

  svg {
    margin: 0;
  }
`;

export const RadioGroupSpacedWrapper = styled.div`
  line-height: 1;
  margin-top: 12px;
  margin-bottom: 12px;

  svg {
    margin: 0;
  }
`;

export const RadioWrapper = styled.div`
  display: flex;
  & label {
    flex-direction: row;
    align-items: center;
  }
`;

const InfoMessage = styled.div`
  color: ${N700};
  font-size: 0.875rem;
  font-weight: 400;
  margin-top: 6px;
`;

const Cursor = styled.div<SharedProps>`
  cursor: ${(props) =>
    props.isDisabled && props.fadeOnDisable ? 'not-allowed' : 'pointer'};
  display: flex;
  align-items: center;
  margin-top: 0;
  @supports (display: grid) {
    display: flex;
    align-items: center;
  }
`;

const SvgContainer = styled.div`
  svg {
    display: block;
    margin-bottom: 0;
  }
`;

const AttentionContainer = styled.div`
  width: 0;
  height: 0;
  left: -29px;
  position: relative;
  top: 6px;
  svg {
    display: block;
    margin-bottom: 0;
  }
`;

const Domain = styled.div`
  color: ${N80};
  font-family: ${display};
  font-size: 1rem;
  letter-spacing: 1px;
`;

const ToolTipContainer = styled.div`
  position: relative;
  display: none;
  @supports (display: grid) {
    display: block;
  }
`;

const ToolTipText = styled.div`
  background: ${N0};
  border: 1px solid ${B400};
  border-radius: 2px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
  color: ${N800};
  font-family: ${text};
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.42857143;
  padding: 12px;
  position: absolute;
  left: 6px;
  top: 25px;
  width: 298px;
`;

const DomainToolTip = styled.div`
  cursor: pointer;
  margin: 0 6px;
  svg {
    height: 18px;
    width: 18px;
  }
`;

const AppRegionContainer = styled.div`
  color: ${N700};
  display: grid;
  grid-template-columns: min-content min-content;
  grid-column-gap: 16px;
  margin-bottom: 24px;
  div {
    display: grid;
    grid-template-columns: min-content min-content;
    grid-column-gap: 8px;
  }
`;

const CheckboxContainer = styled.div`
  color: ${N700};
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-column-gap: 8px;
  font-size: 0.875rem;
  margin-bottom: 16px;
  &.hidden {
    grid-template-columns: 1fr;
    .checkbox {
      display: none;
    }
  }
  .full-width {
    grid-column: 1 / 3;
  }
  p {
    font-size: 0.875rem;
    line-height: 1.25;
    margin: 0;
  }
`;

const SmallPrint = styled.div`
  color: ${N500};
  font-size: 0.75rem;
  margin-bottom: 16px;
  &.compact {
    margin-bottom: 4px;
  }
  p {
    font-size: 0.75rem;
    line-height: 1.25;
    margin: 0;
  }
`;
const ButtonSpinner = styled.div`
  display: inline-block;
  margin-right: 12px;
  margin-left: -28px;
`;

const Button = styled.button`
  border: none;
  border-radius: 3px;
  background-color: ${B400};
  color: ${N0};
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  font-family: ${text};
  min-height: 40px;
  width: 100%;
  &:hover {
    background: ${B300};
  }
  &:active {
    background-color: #0047b3;
  }
  &[disabled] {
    cursor: not-allowed;
    background-color: #0047b3;
  }
`;

const CapsPrint = styled.div`
  color: ${N500};
  font-size: 0.875rem;
  margin-bottom: 16px;
  margin-top: 8px;
  text-align: center;
  text-transform: uppercase;
  @media (min-width: 540px) {
    margin-top: 16px;
  }
`;

const CaptchaContainer = styled.div`
  margin-bottom: 16px;
`;

interface WelcomDivProps {
  readonly headerStyle?: boolean;
}

const WelcomeDiv = styled.div<WelcomDivProps>`
  font-size: 1.25rem;
  line-height: 1.2;
  margin-bottom: 30px;
  letter-spacing: 0.3px;
  font-family: ${display};
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  font-weight: 500;

  ${(props) =>
    props.headerStyle &&
    `
    color: ${N600};
    text-align: center;
    font-size: 32px;
    line-height: 40px;

    @media only screen and (max-width: 769px) {
      font-size: 28px;
      text-align: left;
    }
  `}
`;

export const WelcomeDivDevops = styled.div`
  max-width: 300px;
  margin: 0 auto;
  text-align: center;
`;

export const StyledInfoBoxWrapper = styled.div`
  margin: 12px auto 26px;
`;

const InfoBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${B50};
  padding: 12px 16px;
  border-radius: 3px;
  margin-bottom: 12px;
`;

interface InfoBoxContentProps {
  readonly fontSize?: string;
}

const InfoBoxContent = styled.div<InfoBoxContentProps>`
  width: 93%;

  .title {
    font-weight: 500;
  }

  p {
    font-size: ${({ fontSize }) => {
      if (fontSize) {
        return fontSize;
      } else {
        return '12px';
      }
    }};
    font-weight: 400;
    line-height: 17px;
    margin: 0 0 12px 0;
    color: ${text};

    a {
      color: ${B400};
      text-decoration: none;
      cursor: pointer;

      a:hover {
        color: ${linkHover};
      }
    }

    &.link {
      display: inline-block;
      color: ${B400};
      cursor: pointer;

      &:hover {
        color: ${linkHover};
      }
    }

    &:last-child {
      margin: 0;
    }
  }
`;

const ModalContents = styled.div`
  position: relative;
  font-family: ${text};
  font-size: 14px;
  color: ${text};
  padding: 18px 0;

  .message {
    padding-right: 24px;
    line-height: 22px;
  }

  a {
    color: ${text};
    text-decoration: none;
    font-weight: 500;

    &:focus {
      outline: none;
    }
  }

  .exit {
    position: absolute;
    top: 8px;
    right: -12px;
    cursor: pointer;
  }
`;

const ReCaptchaEula = styled.div`
  margin-top: 40px;
  font-size: 12px;
  color: ${N200};
  line-height: 16px;
  text-align: center;
  > * {
      margin-block-start: 0;
      > a {
        color: ${N200};
        text-decoration: underline;
      }
    }
}
`;

const ReCaptchaEulaDefaultExpandedEmail = styled.div`
  margin-top: 32px;
  margin-bottom: 8px;
  font-size: 12px;
  color: ${N200};
  line-height: 16px;
  text-align: center;
  font-weight: 400;
  > * {
      margin-block-start: 0;
      > a {
        color: ${N200};
        text-decoration: underline;
      }
    }
}
`;

const ReCaptchaEulaChooseSignup = styled.div`
  position: absolute;
  bottom: 60px;
  font-size: 12px;
  color: ${N800};
  line-height: 18px;
  text-align: center;
  font-weight: 400;
  width: 320px;
  font-family: Charlie Text;
  > * {
      margin-block-start: 0;
      > a {
        color: ${B400};
        text-decoration: underline;
      }
    }
  @media only screen and (max-width: 768px) {
    position: relative;
  }
  @media only screen and (max-height: 918px) {
    position: unset;
  }
}
`;

const Eula = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${N200};
  vertical-align: middle;
  padding: 0 0 5px 0;
  font-family: ${text};
  font-weight: 400;

  a {
    color: ${B400};
    text-decoration: none;
    cursor: pointer;
  }

  p {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 24px;
    margin-top: 0;

    &.eula-compass {
      p {
        display: inline;
      }
    }
  }

  div {
    display: inline;
  }

  .tooltip {
    color: ${B400};
    cursor: pointer;
  }
`;

const EulaDefaultExpandedEmail = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${N200};
  vertical-align: middle;
  padding: 0;
  font-family: ${text};
  font-weight: 400;

  a {
    color: ${B400};
    text-decoration: none;
    cursor: pointer;
  }

  p {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 16px;
    margin-top: 0;

    &.eula-compass {
      p {
        display: inline;
      }
    }
  }

  div {
    display: inline;
  }

  .tooltip {
    color: ${B400};
    cursor: pointer;
  }
`;

const EulaChooseSignup = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: ${N400};
  vertical-align: middle;
  padding: 0;
  font-family: ${text};
  font-weight: 400;
  margin-bottom: 8px;
  margin-top: 40px;

  a {
    color: ${B400};
    text-decoration: none;
    cursor: pointer;
  }

  p {
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 0px !important;

    &.eula-compass {
      p {
        display: inline;
      }
    }
  }

  div {
    display: inline;
  }

  .tooltip {
    color: ${B400};
    cursor: pointer;
  }
`;

export const RequiredFieldMessage = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #6c798f;
  vertical-align: middle;
  padding: 0 0 5px 0;
  font-family: ${text};
  font-weight: 400;
`;

export const UnderLabelMessage = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${N800};
  vertical-align: middle;
  padding: 0 0 8px 0;
  font-family: ${text};
  font-weight: 400;
`;

const TooltipDialog = styled(TooltipPrimitive)`
  font-family: ${text};
  box-sizing: content-box;
  border-radius: 4px;
  padding: 8px 12px;
  max-width: 330px;
  background: #0e0e0e;
  color: ${N0};
  font-size: 14px;
  font-weight: 500;

  p {
    margin: 0;
  }

  @media only screen and (max-width: 375px) {
    max-width: 300px;
  }
`;
const SigninWithDiffAccount = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #6c798f;
  vertical-align: middle;
  padding: 5px 0;
  font-family: ${text};
  font-weight: 500;
  > * {
    > * {
      margin-block-start: 0;
      margin-bottom: 0px;
      > a {
        color: ${B400};
        text-decoration: none;
      }
    }
  }
`;

const SitePickerToggle = styled.span`
  display: block;
  font-size: 12px;
  line-height: 16px;
  color: ${B400};
  vertical-align: middle;
  padding: 5px 0;
  margin: 0 0 0 0;
  font-family: ${text};
  font-weight: 500;
  cursor: pointer;
`;

const NoCard = styled.div`
  margin-top: 15px;
  font-weight: 500;
  margin-bottom: 0;
  text-align: center;
  font-size: 0.875rem;
  letter-spacing: 1px;
  line-height: 1.25;
  font-family: ${display};
  font-style: normal;
`;

const NoCardDefaultExpandedEmail = styled.div`
  margin-top: 32px;
  font-weight: 500;
  margin-bottom: 0;
  text-align: center;
  font-size: 0.875rem;
  letter-spacing: 1px;
  line-height: 1.25;
  font-family: ${display};
  font-style: normal;
`;

const NoCardChooseSignup = styled.div`
  font-weight: 600;
  margin-bottom: 8px;
  text-align: center;
  font-size: 0.8rem;
  letter-spacing: 1px;
  line-height: 18px;
  font-family: ${display};
  font-style: normal;
  color: ${N90};
`;

const MarketingConsent = styled.div`
  > label {
    > span {
      border: none !important;
      padding: 0 !important;
      border-radius: 3px;
      margin-bottom: 12px;
      line-height: 20px;
      font-size: 100%;
      vertical-align: baseline;
      font-family: ${display};
      font-style: normal;
      font-size: 13px;
      letter-spacing: 0.3px;
    }
  }
`;

const DeveloperModeDiv = styled.div`
  font-family: ${display};
  font-style: normal;
  border: 1px solid ${N60};
  color: #6c798f;
  border-radius: 6px;
  margin: 20px 0;
  padding: 16px 30px 16px 38px;
  font-size: 14px;
  position: relative;
  h4 {
    font-style: inherit;
    font-family: inherit;
    color: #6c798f;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
  }
  p {
    color: inherit;
    font-size: inherit;
    line-height: 20px;
    font-weight: normal;
    font-family: inherit;
    font-style: inherit;
    margin-bottom: 0;
  }
  ul {
    list-style-type: disc;
    margin-bottom: 8px;
    padding-left: 20px;
  }
`;
const MigrationSourceDiv = styled.div`
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  font-family: ${text}
  font-style: normal;
  span {
    > div {
      font-size: 1.25rem;
      line-height: 1.2;
      margin-bottom: 24px;
      font-weight: 500;
      font-family: inherit;
      font-style: inherit;
    }
    > p {
      font-size: 1rem;
      line-height: 24px;
      margin-bottom: 24px;
      font-family: inherit;
      font-style: inherit;
      font-weight: normal;
      > a {
        color: ${B400};
        text-decoration: none;
        vertical-align: baseline;
        font-family: inherit;
        font-style: inherit;
        font-weight: inherit;
      }
    }
  }
`;

const SitePickerTextfieldWrapper = styled.div`
  > div {
    max-height: 40px;
    background: ${N20} !important;
    border-color: ${N60} !important;
  }

  svg {
    margin-bottom: 0;
  }
`;

const BitbucketAccountCheckbox = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${text};
  max-width: 390px;
  margin-top: 4px;
`;

const RadioLabel = styled.div`
  display: flex;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  flex-direction: column;
  color: ${N900};
  font-family: ${text}
  font-style: normal;
`;

const DevopsCarouselRadioGroup = styled.div`
  margin-top: 27px;
  label {
    margin-bottom: 15px;
    font-size: 14px;
    line-height: 24px;
    color: ${N800};
    font-family: ${text}
    font-style: normal;
  }
`;
const DevopsCarouselWorkspaces = styled.div`
  width: 204px;
`;
const DevopsCarouselSites = styled.div`
  width: 204px;
`;

const BitbucketFieldsContainer = styled.div`
  margin: 24px 0px;
`;

const OrgPickerElementMargin = styled.div`
  margin-top: 24px;
`;

const OrganizationDropdownContainer = styled.div`
  height: 32px;
  border-radius: 3px;
  color: ${N800};

  button {
    background-color: ${N20};
    &:hover {
      cursor: pointer;
    }
  }
`;

const OrganizationDropdownTextContainer = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
`;

const OrganizationDropdownItemContainer = styled.div`
  font-size: 14px;
  height: 34px;
  line-height: 18px;
  color: #172b4d;
  font-weight: 400;
  padding: 8px 4px;
`;

const FieldLabel = styled.div`
  margin-bottom: 5px;

  font-family: ${text};
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0px;
  text-align: left;
  color: ${N500};
`;

const WorkspaceIdPrefix = styled.div`
  height: 40px;
  background-color: ${N20};
  border-right: 2px solid ${N40};
  padding: 8px;

  font-family: ${text};
  font-weight: 400;
  line-height: 24px;
  color: ${N100};
`;

const TextFieldWrapper = styled.div<{ error?: Boolean }>`
  > div {
    border-color: ${(props) => (props.error ? R400 : N40)};
  }

  input {
    margin-top: 0px;
    background-color: ${N10};
    color: ${N100};
  }
`;

const HelperMessageContainer = styled.div`
  font-family: ${text};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${N200};
`;

const OrgProvisioningProgressContainer = styled.div`
  font-family: 'Charlie Display';
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin: 24px auto;
  text-align: center;
  max-width: 253px;
  height: 40px;
`;

const CCPSiteMigrationContainer = styled.div`
  p,
  li {
    font-family: ${text};
    font-weight: 400;
    font-size: 11px;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
`;

export {
  text,
  display,
  product,
  WacSignupFormContainer,
  StyledPassword,
  FieldContainer,
  FieldErrorState,
  FullNameFieldWrapper,
  TwoColumnFieldGroup,
  NameFieldGroup,
  Input,
  Label,
  LabelDefaultExpandedEmail,
  ChooseSignupLabel,
  InputDescription,
  DropdownTrigger,
  DropdownButtonStyle,
  JswTrialNotice,
  DropdownButtonStyleOpen,
  SiteNameAfter,
  SiteNameAfterRadioList,
  SiteNameAfterLabel,
  EmailAfter,
  SuccessTextfieldWrapper,
  ChooseSignupSuccessTextfieldWrapper,
  ErrorTextfieldWrapper,
  CompoundField,
  CompoundInput,
  CompoundInputSegment,
  ErrorMessage,
  ErrorMessageWithDefaultClassName,
  InfoMessage,
  Cursor,
  SvgContainer,
  AttentionContainer,
  Domain,
  ToolTipContainer,
  ToolTipText,
  DomainToolTip,
  AppRegionContainer,
  CheckboxContainer,
  SmallPrint,
  ButtonSpinner,
  Button,
  CapsPrint,
  CaptchaContainer,
  WelcomeDiv,
  InfoBoxContainer,
  InfoBoxContent,
  ModalContents,
  ReCaptchaEula,
  ReCaptchaEulaDefaultExpandedEmail,
  ReCaptchaEulaChooseSignup,
  Eula,
  EulaDefaultExpandedEmail,
  EulaChooseSignup,
  SigninWithDiffAccount,
  SitePickerToggle,
  NoCard,
  NoCardDefaultExpandedEmail,
  NoCardChooseSignup,
  MarketingConsent,
  DeveloperModeDiv,
  MigrationSourceDiv,
  SitePickerTextfieldWrapper,
  BitbucketAccountCheckbox,
  RadioLabel,
  ResendEmailContainer,
  DevopsCarouselRadioGroup,
  DevopsCarouselWorkspaces,
  DevopsCarouselSites,
  TooltipDialog,
  InputSiteNameMessage,
  InputSiteNameInstructions,
  WorkspaceIdPrefix,
  BitbucketFieldsContainer,
  OrgPickerElementMargin,
  OrganizationDropdownContainer,
  OrganizationDropdownTextContainer,
  OrganizationDropdownItemContainer,
  OrganizationDropdownButtonStyle,
  OrganizationDropdownButtonStyleOpen,
  FieldLabel,
  TextFieldWrapper,
  HelperMessageContainer,
  OrgProvisioningProgressContainer,
  CCPSiteMigrationContainer
};
